import React, { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FormValidator from "../../utils/FormValidator"
import NotificationHandler from "../../utils/NotificationHandler"
import { enumUtil } from "../../utils/Enum"
import { ServerRequestProtected } from "../../utils/ServerDataRequest"
import Loader from "../shared/Loader/Loader"
import { ConstructionOutlined, Email, Password } from "@mui/icons-material";
import { Link } from "react-router-dom";
import SignEncounter from "../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/Components/SignEncounter";


const ChangePassword = (props) => {
    const API_URL = enumUtil.controller.Login
    let navigate = useNavigate();
    const location = useLocation();
    const fullResponse = location.state?.fullResponse;
    const year = new Date().getFullYear();
    console.log("Navigated Data:", fullResponse);

    // let navigate = useNavigate();
    let changepassword_Modal = {
        Password: "",
        ConfirmPassword: "",
        // IsBAAAgree: false,
    }
    let valModal = {}

    let ValidationModal = {
        PasswordVal: "",
        PasswordDigitsVal: "",
        ConfirmPasswordVal: "",
        ConfirmPasswordDigitsVal: "",
    }
    const [isLoading, setIsLoading] = useState(false)
    const [mainchangepasswordModal, setmainchangepasswordModal] = useState(changepassword_Modal);
    const [changepasswordSaveUpdateModal, setchangepasswordSaveUpdateModal] = useState({});
    const [changepasswordValidationModal, setchangepasswordValidationModal] = useState(ValidationModal)
    const [comparepasswordValidation, setComparepasswordValidation] = useState(false)
    const [hidePwd, setHidePwd] = useState(true);
    const [hideCnfrmPwd, setHideCnfrmPwd] = useState(true);
    const [isSign, setIsSign] = useState(false);


    const handlechangepasswordChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainchangepasswordModal };
        let saveModal = { ...changepasswordSaveUpdateModal }
        modal[name] = value
        setmainchangepasswordModal(modal)
        for (var property in changepassword_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setchangepasswordSaveUpdateModal(saveModal)
    }

    const changepasswordValidation = async () => {
        let ValidationModal = {
            PasswordVal: FormValidator(
                mainchangepasswordModal.Password,
                enumUtil.enumValidationType.Required,
                'Password',
            ),
            PasswordDigitsVal: FormValidator(
                mainchangepasswordModal.Password,
                enumUtil.enumValidationType.Password,
                'Password',
            ),
            ConfirmPasswordVal: FormValidator(
                mainchangepasswordModal.ConfirmPassword,
                enumUtil.enumValidationType.Required,
                'Confirm Password',
            ),
            ConfirmPasswordDigitsVal: FormValidator(
                mainchangepasswordModal.ConfirmPassword,
                enumUtil.enumValidationType.Password,
                'Confirm Password',
            ),
        }
        await setchangepasswordValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const ComparepasswordValidation = async () => {
        if (mainchangepasswordModal.Password !== mainchangepasswordModal.ConfirmPassword) {
            await setComparepasswordValidation(true)
            return true
        }
        else {
            await setComparepasswordValidation(false)
            return false
        }
    }
    // const hideshow =() =>{
    //     console.log(hidePwd)
    //     setHidePwd(!hidePwd);
    // }

    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const [IsPolicyAgreed, setIsPolicyAgreed] = useState(false);


    // Add this function to handle checkbox change
    const handleAgreeToTerms = (e) => {
        const checked = e.target.checked;
        setAgreeToTerms(checked);
        if (checked) {
            setIsSign(true);
        } else {
            setIsSign(false);
        }
    }
     const handleAgreeToTermspolicy = (e) => {
        const checked = e.target.checked;
        setIsPolicyAgreed(checked);
    }

    const getSaveData = async (_, filename, base64) => {
        console.log("get Save Data Sign ,", filename, base64);
        // let newData = {
        //     "SignatureFileName": filename,
        //     "SignaturePath": base64
        // }
        let newData = {
            "SignBAA": base64
        }
        // setmainProvidereModal(prev => ({ ...prev, ...newData }))
        setchangepasswordSaveUpdateModal(prev => ({ ...prev, ...newData }))
    }
    const handleSubmit = async (event) => {
        await changepasswordValidation()
        let compareValidation = await ComparepasswordValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            console.log("valModal", valModal);
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else if (compareValidation == false && validation == false) {
            // Validate agreeToTerms checkbox
            if (!agreeToTerms ) {
                NotificationHandler('Please agree to the Business Associate Agreement and Privacy Policy', enumUtil.enumtoaster.error)
                return
            }
             if (!IsPolicyAgreed ) {
                NotificationHandler('Please agree to the Privacy Policy and Terms of Service', enumUtil.enumtoaster.error)
                return
            }

            console.log("Accept")
            let data = { ...changepasswordSaveUpdateModal, IsBAAAgree: agreeToTerms, IsPolicyAgreed: IsPolicyAgreed }


            // Validate SignBAA signature
            if (!data?.SignBAA) {
                NotificationHandler('Please sign the Business Associate Agreement', enumUtil.enumtoaster.error)
                return
            }

            console.log(data, 'datasave');

            var url = fullResponse?.url;
            console.log(url, 'urlllllllllllllllllllllll');

            const urlParts = url.split('?');
            const params = urlParts[1].split('&');

            var obj = {};
            for (var i in params) {
                const keyValues = params[i].split('=');
                const newItemInput = keyValues[0];
                const newRadioValue = keyValues[1];
                obj[newItemInput] = newRadioValue;
            }
            if (obj) {
                setIsLoading(true)
                ServerRequestProtected(API_URL + "/ResetPassword", 'post', {
                    ...data, ...obj
                }).then((response) => {
                    setIsLoading(false)
                    event.preventDefault();
                    NotificationHandler('Changed Successfully', enumUtil.enumtoaster.success)
                    navigate("../", { replace: true });
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error.response.data);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                    //  navigate("../", { replace: true });
                })
            }
        }
    }


    const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <React.Fragment >
            {/* {isLoading ? <Loader /> : null} */}


            <div className="ar_login-screen">
                <div className="ar-main-screen-content w-100 d-flex align-items-center flex-column gap-25 justify-content-center">
                    <div className="login-content">
                        <div className="img-container h-auto s-70 mx-auto mb-15">
                            <img src={process.env.PUBLIC_URL + "/assets/images/lock-password.png"} alt="" />
                        </div>
                        <div className="mb-2 d-flex flex-column align-items-center">
                            <p className='fs-20 heading lh-normal'>Set new password</p>
                            <p className='text fs-11 color-muted lh-normal'>Your new password must be different to previously used password</p>
                            {changepasswordValidationModal.PasswordDigitsVal || changepasswordValidationModal.ConfirmPasswordDigitsVal ?
                                <div className={"text forget-p rest-pswd-sc za-red-clr Denied-clr mt-2"}>
                                    {changepasswordValidationModal.PasswordDigitsVal || changepasswordValidationModal.ConfirmPasswordDigitsVal}
                                </div> : null}
                        </div>
                        <div className="d-flex flex-column gap-20 br-bottom-1 za_br_light pb-4 mb-4">
                            <div className={changepasswordValidationModal.PasswordVal ? "form-group input hk-password-field error m-0" : changepasswordValidationModal.PasswordDigitsVal ? "form-group input m-0 hk-password-field error" : "form-group input m-0 hk-password-field"}>
                                <label >Password</label>
                                <div className="position-relative">
                                    <input type={hidePwd ? "password" : "text"}
                                        className="form-control"
                                        name="Password"
                                        id="Password"
                                        value={mainchangepasswordModal.Password}
                                        onChange={handlechangepasswordChange}
                                    />
                                    <div className="hk-eye-btn top-50 translate-middle-y" onMouseDown={() => setHidePwd(false)} onMouseUp={() => setHidePwd(true)} onMouseLeave={() => setHidePwd(true)}>
                                        {hidePwd ? <i class="icon-eye-blocked"></i> : <i class="icon-eye"></i>}
                                    </div>
                                    {changepasswordValidationModal.PasswordVal}
                                </div>
                            </div>

                            <div className={changepasswordValidationModal.ConfirmPasswordVal ? "form-group input m-0 hk-password-field error" : changepasswordValidationModal.ConfirmPasswordDigitsVal ? "form-group input m-0 hk-password-field error" : "form-group input m-0 hk-password-field"}>
                                <label>Confirm Password</label>
                                <div className="position-relative">
                                    <input type={hideCnfrmPwd ? "password" : "text"}
                                        className="form-control"
                                        name="ConfirmPassword"
                                        id="ConfirmPassword"
                                        value={mainchangepasswordModal.ConfirmPassword}
                                        onChange={handlechangepasswordChange}
                                    />
                                    <div className="hk-eye-btn top-50 translate-middle-y" onMouseDown={() => setHideCnfrmPwd(false)} onMouseUp={() => setHideCnfrmPwd(true)} onMouseLeave={() => setHideCnfrmPwd(true)}>
                                        {hideCnfrmPwd ? <i class="icon-eye-blocked"></i> : <i class="icon-eye"></i>}
                                    </div>
                                    {changepasswordValidationModal.ConfirmPasswordVal}
                                </div>
                            </div>

                            {!changepasswordValidationModal.PasswordVal && !changepasswordValidationModal.PasswordDigitsVal && !changepasswordValidationModal.ConfirmPasswordVal && !changepasswordValidationModal.ConfirmPasswordDigitsVal && comparepasswordValidation ? (
                                <div className={comparepasswordValidation ? "form-group input error m-0" : "form-group input m-0"}>
                                    <label>Password and Confirm Password must be same</label>
                                </div>
                            ) : null}
                            <div className='d-flex align-items-center gap-2 checkbox-multiline-alignment'>
                                <label className="custom_check_box d-flex gap-2 m-0">
                                    <input
                                        type="checkbox"
                                        className="form-check-input m-0 p-0"
                                        name='IsBAAAgree'
                                        id='IsBAAAgree'
                                        checked={agreeToTerms}
                                        onChange={handleAgreeToTerms}
                                    />
                                    <p className="text fs-11 user-select-none m-0">
                                        On behalf of myself and the practice, I agree to the{' '}
                                        <a href="https://starhealthcare.co/BusinessAssociateAgreement" target="_blank" className="link-orange text-decoration-none">Business Associate Agreement(BAA).</a>
                                        {/* </a> and{' '} */}
                                        {/* <a href="https://starhealthcare.co/PrivacyPolicy" target="_blank" className="link-orange text-decoration-none">Privacy Policy</a> for my account */}
                                    </p>
                                </label>

                            </div>
                            <div className='d-flex align-items-center gap-2'>
                                <label className="custom_check_box d-flex align-items-center gap-2 m-0">
                                    <input
                                        type="checkbox"
                                        className="form-check-input m-0 p-0"
                                        name='IsPolicyAgreed'
                                        id='IsPolicyAgreed'
                                        checked={IsPolicyAgreed}
                                        onChange={handleAgreeToTermspolicy}
                                    />
                                    <p className="text fs-11 user-select-none m-0">
                                        I agree to the   <a href="https://starhealthcare.co/PrivacyPolicy" target="_blank" className="link-orange text-decoration-none">Privacy Policy</a> and{' '}

                                        <a href="https://starhealthcare.co/TermsOfService" target="_blank" className="link-orange text-decoration-none">Terms of Service </a> for my account.</p>

                                </label>
                            </div>
                            <div className='position-relative login-btn-loader'>
                                <input type="submit" value={`${isLoading === true ? '' : 'Reset password'}`} className="btn rounded btn-orange heading w-100" onClick={handleSubmit} />

                                {isLoading === true ?
                                    <div className='last_loader ar-small-loader'>
                                        <div className="circle circle1"></div>
                                        <div className="circle circle2"></div>
                                    </div> :
                                    null}
                            </div>

                            <a className="text text-center inst-txt text-decoration-none" onClick={() => navigate("../", { replace: true })}><span class="icon-Icon-ionic-md-arrow-round-back fs-9"></span> Back to Login</a>
                        </div>

                        <div className="d-flex align-items-center justify-content-center">
                            <p className='text fs-12 color-95 '>©{year} {ThemeConfiguration?.configuration?.company?.name}. All rights reserved</p>
                        </div>
                    </div>
                </div>
            </div>
            <SignEncounter
                isSign={isSign}
                setIsSign={setIsSign}
                providerName={`${fullResponse?.firstName}`}
                setSearchParam={() => { }}
                getSaveData={getSaveData}
                // item={item}
                isOpenedFrom={'User'}
            />
        </React.Fragment>
    )
}
export default ChangePassword